import { useEpisode } from "@/containers/Episode/context";
import InsightBadge, { SETTINGS } from "@/containers/InsightBadge";
import { i18n } from "@lingui/core";

const Insights = () => {
  const { insights } = useEpisode();

  if (!(insights && insights.length)) return null;

  return (
    <>
      {insights?.map((type, i) => {
        const settings = SETTINGS[type];
        return (
          <InsightBadge
            size="sm"
            type={type}
            data-testid="insight-badge"
            key={`insight-highlight-${i}`}
          >
            {i18n._(settings?.label || "")}
          </InsightBadge>
        );
      })}
    </>
  );
};

export default Insights;
